import { withStyles } from '@material-ui/core/styles';
import { TablePagination } from '@material-ui/core';

// The `withStyles()` higher-order component is injecting a `classes`
// property that is used by the `Button` component.
const styles = theme => ({
  root: {
		letterSpacing: 0.4
  },
  // label: {
  //   textTransform: 'capitalize',
	// },
	toolbar: {
    height: 64,
    minHeight: 64,
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      paddingRight: 35,
    }
	},
	select: {
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      paddingRight: 26,
    }
  },
  actions: {
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 20
    }
  },
});

const CustomTablePagination = withStyles(styles)(TablePagination);
export default CustomTablePagination;



// WEBPACK FOOTER //
// ./src/js/components/Mui/CustomTablePagination.js